@if (chartData()) {
  <cfp-card [fullHeight]="true">
    <div class="d-flex">
      <h2 class="card-title">{{ 'roadmap.labelDistribution' | translate }}</h2>
      <div class="ms-auto d-print-none">
        @if (!labelGroup() && groupedIndexTypes().length > 1) {
          <select
            class="form-control form-control-sm"
            [ngModel]="groupedIndexType()"
            (ngModelChange)="setGroupedIndexType($event)"
          >
            @for (groupedIndexType of groupedIndexTypes(); track groupedIndexType.labelGroup) {
              <option [ngValue]="groupedIndexType">
                {{ 'energy.label.indexType.' + groupedIndexType.labelGroup | translate }}
              </option>
            }
          </select>
        }
      </div>
    </div>
    <div class="chart-responsive">
      <div class="chart-wrapper">
        <canvas
          class="chart-canvas"
          baseChart
          [datasets]="chartData().datasets"
          [labels]="chartData().labels"
          [type]="chartType"
          [options]="chartOptions"
          role="img"
          [attr.aria-label]="getTranslation('roadmapChart.ariaLabel.labels')"
        >
        </canvas>
      </div>
    </div>
    <div class="mt-2 d-print-none">
      <cfp-link (click)="showData()">{{ 'show.data' | translate }} <cfp-icon [icon]="'angle-right'" /></cfp-link>
    </div>
  </cfp-card>
}
